import { Box, Grid, Paper } from "@mui/material";
import UserEditor from "../fragments/UserEditor";
import { PRIMARY_COLOR } from "../App";
import UserOverview from "../fragments/UserOverview";


export default function Profile(props) {

    const appAPI = props.appAPI;
    const contextAPI = props.contextAPI;
    const userId = props.userId;

    return (
        <Grid spacing={5} container>
            <Grid item xs={12}>
                <Box style={{height: "50px"}} />
            </Grid>
            <Grid item xs={12}>
                <UserOverview
                    appAPI={appAPI}
                    contextAPI={contextAPI}
                    userId={userId}
                />
            </Grid>
        </Grid>
    )
}
